// src/pages/agendamentos/CamposAgendamento.jsx
import { ChevronDown } from "lucide-react";
import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function CamposAgendamento({
  data,
  setData,
  hora,
  setHora,
  dataFinalizado,
  setDataFinalizado,
  empresa,
  setEmpresa,
  clientes,
}) {
  const [openEmpresa, setOpenEmpresa] = useState(false);
  const refEmpresa = useRef(null);

  // 🔹 Fecha dropdown ao clicar fora
  useEffect(() => {
    const handler = (e) => {
      if (refEmpresa.current && !refEmpresa.current.contains(e.target)) {
        setOpenEmpresa(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const inputBase = `
    peer w-full h-10 px-2 border-b border-gray-300
    focus:border-blue-600 focus:outline-none bg-transparent
    text-base text-gray-900 placeholder-transparent
  `;

  const labelBase = (v) => `
    absolute left-2 transition-all duration-200 pointer-events-none
    ${v ? "-top-4 text-sm font-bold text-gray-900" : "top-2 text-base text-gray-400"}
    peer-focus:-top-4 peer-focus:text-sm peer-focus:font-bold peer-focus:text-gray-900
  `;

  const clientesFiltrados = clientes.filter((c) =>
    [c.nome_fantasia, c.razao_social]
      .join(" ")
      .toLowerCase()
      .includes(empresa.toLowerCase())
  );

  const selecionarEmpresa = (nome) => {
    setEmpresa(nome);
    setOpenEmpresa(false);
  };

  return (
    <div className="flex flex-row gap-6">
      {/* Data Abertura */}
      <div className="relative flex-[0.5] min-w-[110px]">
        <input
          type="date"
          value={data}
          onChange={(e) => setData(e.target.value)}
          className={inputBase}
          placeholder=" "
        />
        <label className={labelBase(data)}>Data Abertura</label>
      </div>

      {/* Hora */}
      <div className="relative flex-[0.5] min-w-[100px]">
        <input
          type="time"
          value={hora}
          onChange={(e) => setHora(e.target.value)}
          className={inputBase}
          placeholder=" "
        />
        <label className={labelBase(hora)}>Hora</label>
      </div>

      {/* Data Finalizado */}
      <div className="relative flex-[0.5] min-w-[110px]">
        <input
          type="date"
          value={dataFinalizado}
          onChange={(e) => setDataFinalizado(e.target.value)}
          className={inputBase}
          placeholder=" "
        />
        <label className={labelBase(dataFinalizado)}>Data Finalizado</label>
      </div>

      {/* Nome da Empresa */}
      <div className="relative flex-[2] min-w-[200px]" ref={refEmpresa}>
        <input
          type="text"
          value={empresa}
          onChange={(e) => {
            setEmpresa(e.target.value);
            setOpenEmpresa(true);
          }}
          className={inputBase}
          placeholder=" "
        />
        <label className={labelBase(empresa)}>Nome da Empresa</label>

        <ChevronDown
          size={16}
          className={`absolute right-1 top-3 cursor-pointer transition-transform ${
            openEmpresa ? "rotate-180" : ""
          }`}
          onClick={() => setOpenEmpresa((o) => !o)}
        />

        <AnimatePresence>
          {openEmpresa && (
            <motion.ul
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -5 }}
              transition={{ duration: 0.2 }}
              className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 
                         rounded-md shadow-md z-10 max-h-52 overflow-y-auto"
            >
              {clientesFiltrados.length ? (
                clientesFiltrados.map((c) => (
                  <li
                    key={c.codigo}
                    className="border-b border-gray-200 last:border-0"
                  >
                    {/* Razão Social */}
                    <div
                      className="px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-blue-100"
                      onMouseDown={() => selecionarEmpresa(c.razao_social)}
                    >
                      {c.razao_social}
                    </div>

                    {/* Nome Fantasia */}
                    {c.nome_fantasia &&
                      c.nome_fantasia !== c.razao_social && (
                        <div
                          className="px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-blue-100 pl-5"
                          onMouseDown={() =>
                            selecionarEmpresa(c.nome_fantasia)
                          }
                        >
                          {c.nome_fantasia}{" "}
                          <span className="text-gray-400 text-xs">(fantasia)</span>
                        </div>
                      )}
                  </li>
                ))
              ) : (
                <li className="px-3 py-2 text-sm text-gray-500">
                  Nenhum cliente encontrado
                </li>
              )}
            </motion.ul>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
